import React, {useState, useEffect}  from 'react'
import {Form, Select} from 'antd';
import {deepCompare} from '../utills/common'

//无状态组件
function SelectFormItem(props) {
    const [options, setOptions] = useState([]);
    const dataKey = props.dataKey || 'id';
    const dataValue = props.dataValue || 'value';
    const dataContent = props.dataContent || 'content';
    const dataContent2 = props.dataContent2 || 'content2';
    useEffect(() => {
        const options = [];
        if (props.data != null && Array.isArray(props.data) && props.data.length >= 0) {
            props.data.forEach(
                d => {
                    options.push(<Select.Option key={d[dataKey]}
                                                value={d[dataValue]}>{d[dataContent]} {d[dataContent2]}</Select.Option>)
                });
            setOptions(options);
        }
    }, [props.data]);
    return <Form.Item label={props.label} {...props.layout}>
        {props.getFieldDecorator(props.name, {
            initialValue: props.initialValueNull ? props.initialValue :
                (props.initialValue ? props.initialValue : ((props.data != null && props.data.length > 0 ? props.data[0][dataValue] : ''))),
            rules: [{required: false || props.required, message: '该项必填'}]
        })(<Select onChange={props.handleChange} style={props.style}
                   getPopupContainer={triggerNode => triggerNode.parentNode}
                   disabled={props.disabledOpt} allowClear>
            {options}
        </Select>)}
    </Form.Item>
}
/*
 SelectAreaFormItem.propTypes = {
 operation: PropTypes.func,
 disabledOpt: PropTypes.bool,
 options: PropTypes.array,
 realValue: PropTypes.string,
 };
 const areEqual = (prevprops, nextprops) => {
 /!** 与shouldComponentUpdate相似，但是这是用来判断prevprops和nextprops是否相等，相
 **  等返回true,组件不发生重新渲染；反之，组件重新渲染。主要用于性能优化，不要过于依
 **  赖，容易发生bug
 **!/
 const flag = prevprops.value === nextprops.value && deepCompare(prevprops.data, nextprops.data);
 return flag;
 }
 export default React.memo(SelectAreaFormItem, areEqual);*/
export default SelectFormItem;

